import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createShareUrlRequest = { shareUrl: '_shareUrl' };
var _createShareUrlResponse = { shareUrl: '_shareUrl' };
var _disableShareUrlRequest = {};
var _disableShareUrlResponse = {};
var _getShareUrlRequest = {};
var _getShareUrlResponse = { shareUrl: '_shareUrl' };
var _listShareUrlsRequest = {};
var _listShareUrlsResponse = { shareUrls: '_shareUrl' };
var _shareUrl = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixDevcenterV1AppShareUrlServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-share-url-service',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/app-share-url-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/app-share-url-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a ShareUrl.
 *
 * The request body must include lorem and business address. Ipsum is optional.
 */
export function createShareUrl(payload) {
    var _a = serializer(_createShareUrlRequest, { _shareUrl: _shareUrl }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createShareUrlResponse, {
        _shareUrl: _shareUrl,
    }).fromJSON;
    function __createShareUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.share_url',
            method: 'POST',
            methodFqn: 'wix.devcenter.v1.AppShareUrlService.CreateShareUrl',
            url: resolveWixDevcenterV1AppShareUrlServiceUrl({
                protoPath: '/v1/share-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createShareUrl.fromReq = fromReq;
    __createShareUrl.__isAmbassador = true;
    return __createShareUrl;
}
/** Retrieves a ShareUrl. */
export function getShareUrl(payload) {
    var _a = serializer(_getShareUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getShareUrlResponse, { _shareUrl: _shareUrl }).fromJSON;
    function __getShareUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.share_url',
            method: 'GET',
            methodFqn: 'wix.devcenter.v1.AppShareUrlService.GetShareUrl',
            url: resolveWixDevcenterV1AppShareUrlServiceUrl({
                protoPath: '/v1/share-url/{shareUrlId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getShareUrl.fromReq = fromReq;
    __getShareUrl.__isAmbassador = true;
    return __getShareUrl;
}
/**
 * Deletes a ShareUrl.
 *
 *
 * Deleting a ShareUrl permanently removes them from the ShareUrl List.
 */
export function disableShareUrl(payload) {
    var _a = serializer(_disableShareUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disableShareUrlResponse, {}).fromJSON;
    function __disableShareUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.share_url',
            method: 'DELETE',
            methodFqn: 'wix.devcenter.v1.AppShareUrlService.DisableShareUrl',
            url: resolveWixDevcenterV1AppShareUrlServiceUrl({
                protoPath: '/v1/share-url/{shareUrlId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disableShareUrl.fromReq = fromReq;
    __disableShareUrl.__isAmbassador = true;
    return __disableShareUrl;
}
/**
 * Retrieves a list of ShareUrls, given the provided [paging, filtering, and sorting][1].
 *
 * Up to 1,000 ShareUrls can be returned per request.
 *
 * To learn how to query ShareUrls, see [API Query Language][2].
 *
 * [1]: https://dev.wix.com/api/rest/getting-started/sorting-and-paging
 * [2]: https://dev.wix.com/api/rest/getting-started/api-query-language
 */
export function listShareUrls(payload) {
    var _a = serializer(_listShareUrlsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listShareUrlsResponse, {
        _shareUrl: _shareUrl,
    }).fromJSON;
    function __listShareUrls(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.v1.share_url',
            method: 'GET',
            methodFqn: 'wix.devcenter.v1.AppShareUrlService.ListShareUrls',
            url: resolveWixDevcenterV1AppShareUrlServiceUrl({
                protoPath: '/v1/share-urls',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listShareUrls.fromReq = fromReq;
    __listShareUrls.__isAmbassador = true;
    return __listShareUrls;
}
//# sourceMappingURL=http.impl.js.map